module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAdCAYAAADLnm6HAAAA+0lEQVRIS+3XMSvFYRTH8c8Nk8EruK9AFiWLZLiLsrAoGWzKIpP3oJtBvASbUcpCmCiLvAFlk0E2Azp1/wr7OXf4nzfw+/Z9zjnP83Qwi3NMyK0PrHdwiYXc7J+0pwB4xGQRwHsA7GC/COAgAKI2sYSRJJAvXKHfACTl/o9pAVoDQ2NgBosYSxqHz8EYXoSBFZygwsZ2hN4hDFTUSwDcY7oiHa8BsIbjIoDd5tznsZzYhHEXxBvktKLxfsluAVoDQ2NgdTCGo0n7IO6CaxyGgS0cJQX/jdkLgAdMFQG8BcAN5ooAngMg1vAZxpMhog82minoopf8L7iNX9k3CDMlSymk9gUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ai-kind.png
// module id = mOFy
// module chunks = 2